export const SETTINGS_LOCAL_STORAGE_KEY = 'settings';

export const SELECTED_LANGUAGE_LOCALSTORAGE_KEY = '@synergies-addin/language/v2';
